import React from 'react';
import { ArrowRightIcon, BitcoinIcon, CoinsIcon, LineChartIcon, RefreshCwIcon } from 'lucide-react';
import { MARKETS } from '../data/content';
import { Reveal } from './Reveal';
import { AFFILIATE_URL, trackRegisterClick } from '../utils/tracking';
const ICONS: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  forex: RefreshCwIcon,
  indices: LineChartIcon,
  metales: CoinsIcon,
  cripto: BitcoinIcon
};
export function Markets() {
  return <section id="mercados" className="bg-canvas py-16 sm:py-24" data-id="element-141" data-mp="2kjcnloinludm">
      <div className="mx-auto max-w-[1240px] px-4 sm:px-6 lg:px-8" data-id="element-142" data-mp="2piyy3q73kwiq">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-143" data-mp="2uagt7xmfw2vs">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-144" data-mp="2ud36mdw0hclx">
            Oportunidades
          </p>
          <h2 className="mt-4 text-[1.9rem] font-semibold leading-[1.1] tracking-[-0.025em] text-ink-900 sm:text-[2.6rem]" data-id="element-145" data-mp="349prv3s925oh">
            Explora diferentes mercados
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-ink-500 sm:text-[16px]" data-id="element-146" data-mp="2z7rqn4jarfoq">
            Una experiencia diseñada para quienes buscan acceder a diferentes
            categorías de mercados desde una plataforma digital.
          </p>
        </Reveal>

        <ul className="mt-10 grid grid-cols-2 gap-3 sm:mt-12 sm:gap-5 lg:grid-cols-4" data-id="element-147" data-mp="2pa3r81aqxk08">
          {MARKETS.map((market, i) => {
          const Icon = ICONS[market.key];
          const name = market.title.charAt(0) + market.title.slice(1).toLowerCase();
          return <Reveal key={market.key} delay={i * 0.05} className="h-full" data-id="element-148" data-mp="3d0hc97uwyilb" data-mpi={i}>
                <li className="h-full" data-id="element-149" data-mp="387y26kvfq5l9">
                  <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer sponsored" onClick={() => trackRegisterClick('market_card', market.title)} className="group flex h-full flex-col rounded-2xl border border-line bg-white p-4 shadow-card transition-[transform,box-shadow,border-color] duration-200 ease-expo hover:-translate-y-1 hover:border-brand-200 hover:shadow-lift sm:p-7" data-id="element-150" data-mp="386mvodalujqg">
                    <span className="grid h-10 w-10 place-items-center rounded-xl bg-brand-100 text-brand-600 transition-colors duration-200 ease-expo group-hover:bg-brand-600 group-hover:text-white sm:h-12 sm:w-12" data-id="element-151" data-mp="1z1nw0c65gdl5">
                      <Icon className="h-5 w-5" data-id="element-152" data-mp="1ba0cwgf4q6tf" />
                    </span>
                    <h3 className="mt-4 text-[16px] font-semibold tracking-[-0.01em] text-ink-900 sm:mt-6 sm:text-[19px]" data-id="element-153" data-mp="1bc3dfudwrice">
                      {name}
                    </h3>
                    <p className="mt-2 text-[13px] leading-relaxed text-ink-500 sm:mt-3 sm:text-[14.5px]" data-id="element-154" data-mp="11d4beunnekyd">
                      {market.description}
                    </p>
                    <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[13px] font-semibold text-brand-600 sm:pt-7 sm:text-[14px]" data-id="element-155" data-mp="2vpkg3r0spr14">
                      Operar {name}
                      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-156" data-mp="p1200lb25s0x" />
                    </span>
                  </a>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}